export default __webpack_public_path__ + "static/media/character.d0573775.svg";